module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAc0lEQVQ4y2NgGBxg4b3/+DDropv/uRddAWMQGy5HjAHMC2//V1u267/nqhn/3VbNArNBYiQZYLdy0f+rewTBGMQmyQAQ9ls9GW6A9+qppHtBeekeuBcUlu4n3QUEA/HXJcb/5GDqGaCQYPufHDyIDBjaAACJjGmb7RROTgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/RW.png
// module id = 1254
// module chunks = 0